import React from "react";
import { ReactComponent as MailLogo } from "../../icons/mail.svg";
import { ReactComponent as LinkedinLogo } from "../../icons/linkedin.svg";
import { ReactComponent as TwitterLogo } from "../../icons/twitter.svg";
import { ReactComponent as GithubLogo } from "../../icons/github.svg";

const Contact = () => {
  return (
    <div className="2xl:p-40 sm:p-20 pt-20 w-full h-full relative overflow-hidden">
      <h1 className="2xl:text-5xl sm:text-4xl text-3xl px-1 pb-8 text-yellow-50 font-bold ">
        Contact me
      </h1>
      {/* <p className="text-lg">
        I am available for hire and open to any ideas of cooperation.
      </p> */}
      <div className="flex pt-5 gap-12 px-1">
        {/* <div>
          <p>E-mail:</p>
        </div> */}
        <div className="flex gap-2 mb-5">
          <MailLogo className="w-10 h-10 mt-1" fill="rgba(252,211,77)" />
          <a
            href="mailto:anargiriss@hotmail.com"
            className="text-yellow-300 2xl:text-3xl  text-2xl hover:underline pt-1"
            target="_blank"
            rel="noreferrer"
          >
            anargiriss@hotmail.com
          </a>
        </div>
      </div>
      <div className="flex gap-9 mb-5 px-1">
        {/* <div>
          <p>LinkedIn:</p>
        </div> */}
        <div className="flex gap-2">
          <LinkedinLogo className="h-10 w-10 mt-1" fill="rgba(252,211,77)" />
          <a
            className="text-yellow-300 2xl:text-3xl text-2xl hover:underline pt-1"
            href="https://www.linkedin.com/in/anargyros-stylidis-2b18501b2/"
            target="_blank"
            rel="noreferrer"
          >
            astylidis
          </a>
        </div>
      </div>
      <div className="flex gap-12 mb-5 px-1">
        {/* <div>
          <p>Twitter:</p>
        </div> */}
        <div className="flex gap-2">
          <TwitterLogo className="h-10 w-10 mt-1" fill="rgba(252,211,77)" />
          <a
            className="text-yellow-300 2xl:text-3xl text-2xl hover:underline pt-1"
            href="https://twitter.com/AStylidis"
            target="_blank"
            rel="noreferrer"
          >
            @AStylidis
          </a>{" "}
        </div>
      </div>
      <div className="flex gap-12 mb-5 px-1">
        {/* <div>
          <p>Github:</p>
        </div> */}
        <div className="flex gap-2">
          <GithubLogo className="h-10 w-10 mt-1" fill="rgba(252,211,77)" />
          <a
            href="https://github.com/anargiris"
            className="text-yellow-300 2xl:text-3xl text-2xl hover:underline pt-1"
            target="_blank"
            rel="noreferrer"
          >
            anargiris
          </a>{" "}
        </div>
      </div>
      <div className="absolute w-full bottom-0">
        <div className="sm:hidden opacity-40 bottom-0">
          <div className="w-full h-20 bg-yellow-300"></div>
          <div className="w-full h-20 bg-yellow-200"></div>
          <div className="w-full h-20 bg-yellow-100"></div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
